<template>
  <div>
    <div class="mt-3 aulas-btns">
      <v-btn
        icon
        :to="{ name: 'diario-escolar-parecer-descritivo', params: { ano, cdturma, disciplina, cdinstruc, tipoDeEnsino } }">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" dark class="mb-3">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card class="pa-3 mt-2">
      <form @submit.prevent="onSubmit">
        <div class="parecer-labels">
          <div><strong>Aluno: </strong> {{ aluno }}</div>
          <div><strong>Período Avaliativo: </strong> {{ periodoAvaliativo }}</div>
        </div>
        <div>
          <InputDate label="Data do Parecer" v-model="form.dataparecer" :v="$v.form.dataparecer" :disabled="(acao === 'editar')"/>
          <Select label="Situação Final" :disabled="!ultimoPeriodo" v-model="form.indicasituacaofinal" :v="$v.form.indicasituacaofinal" :options="optionsSituacaoFinal"/>
          <TextArea label="Habilidades Cognitivas/Motoras" v-model="form.descricaohabicognitivasmotoras" :v="$v.form.descricaohabicognitivasmotoras"/>
          <TextArea class="mt-4" label="Habilidades Comportamentais" v-model="form.descricaohabilicomportamentais" :v="$v.form.descricaohabilicomportamentais"/>
          <TextArea class="mt-4" label="Observação" v-model="form.descricaoobservacao" :v="$v.form.descricaoobservacao"/>
          <div style="text-align: right">
            <v-btn class="rounded-sm font-weight-regular me-4" type="submit" :loading="loading" small dark color="teal">Salvar</v-btn>
            <v-btn class="rounded-sm font-weight-regular" type="button" :loading="loading" small dark color="error" @click="excluir()" v-if="(acao === 'editar')">Excluir</v-btn>
          </div>
        </div>
      </form>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment'
import store from '@/store/index';
import { required, maxLength } from 'vuelidate/lib/validators';
import { alphaNumSpaceEnter } from '@/validations';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');


const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

const setFormInicial = (props) => {
  const dadosUsuario = dadosUser();
  return {
    aaletivo: props.ano,
    cdtipesc: dadosUsuario.cdtipesc,
    cdescola: dadosUsuario.cdescola,
    cdpessoal: dadosUsuario.cdpessoal,
    cdmatric: dadosUsuario.cdmatric,
    cdturma: props.cdturma,
    cddiscipl: props.disciplina,
    numatalun: props.numatalun,
    cdpravadi: props.cdpravadi,
    dataparecer: '',
    indicasituacaofinal: null,
    descricaohabicognitivasmotoras: '',
    descricaohabilicomportamentais: '',
    descricaoobservacao: '',
  }
};

export default {
  name: 'ParecerCadastro',
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    cdinstruc: [Number],
    disciplina: [String, Number],
    numatalun: [String, Number],
    cdpravadi: [String, Number],
    tipoDeEnsino: [String],
    ultimoPeriodo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: setFormInicial(this.$props),
      aluno: '',
      periodoAvaliativo: '',
      optionsSituacaoFinal: [
        { value: null, text: '' },
        { value: 'A', text: 'Aprovado' },
        { value: 'R', text: 'Reprovado' },
      ],
      loading: false,
      msgArrayError: [],
      submitText: '',
      snackbar: false,
      aaletivo: this.ano,
      codinstruc: this.cdinstruc,
      acao: ''
    };
  },
  validations() {
    return {
      form: {
        aaletivo: { required },
        cdtipesc: { required },
        cdescola: { required },
        cdpessoal: { required },
        cdmatric: { required },
        cdturma: { required },
        cddiscipl: { required },
        numatalun: { required },
        cdpravadi: { required },
        dataparecer: { required, isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
        //indicasituacaofinal: { required: ((this.ultimoPeriodo) ? required : '') },
        descricaohabicognitivasmotoras: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
        descricaohabilicomportamentais: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
        descricaoobservacao: { maxLength: maxLength(2000), alphaNumSpaceEnter },
      },
    };
  },
  async beforeRouteEnter(to, from, next){
    if(
      typeof to.params.ano === 'undefined' || typeof to.params.cdturma === 'undefined' || typeof to.params.disciplina === 'undefined'
      || typeof to.params.numatalun === 'numatalun' || typeof to.params.cdpravadi === 'cdpravadi'
    ){
      return next('/diario-escolar');
    }
    try {
      const { data } = await DiarioEscolarRepository.getParecerDescritivo({
        ...dadosUser(),
        aaletivo: to.params.ano,
        cdturma: to.params.cdturma,
        cddiscipl: to.params.disciplina,
        numatalun: to.params.numatalun,
        cdpravadi: to.params.cdpravadi,
      });
      return next(vm => {
        vm.load(data.results);
      });
    } catch(error) { }
  },
  methods: {
    load({ parecer, aluno, dspravadi, dataAtual }) {
      this.form.dataparecer = moment(dataAtual, 'YYYY-MM-DD').format('DD/MM/YYYY');
      if(parecer) {
        this.form = { ...parecer,
                       dataparecer: moment(parecer.dataparecer, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                    };
        this.acao = 'editar';
      }
      else {
        this.acao = 'novo';
      }
      this.aluno = aluno;
      this.periodoAvaliativo = dspravadi;
      this.$Progress.finish();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        this.loading = true;
        const form = {
          ...this.form,
          dataparecer: moment(this.form.dataparecer, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }
        const { data } = await DiarioEscolarRepository.postParecerDescritivo({
          data: form,
          aaletivo: this.aaletivo,
          cdinstruc: this.cdinstruc,
          });

        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.$router.push({
          name: 'diario-escolar-parecer-descritivo',
          params: {
            ano: this.ano,
            cdturma: this.cdturma,
            disciplina: this.disciplina,
            cdinstruc: this.cdinstruc,
            tipoDeEnsino: this.tipoDeEnsino,
          },
        });
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
      } finally {
        this.loading = false;
      }
    },
    async excluir() {
      console.log(this.form)
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este parecer descritivo?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });
      if(!confirmar) { return; }

      try {
        const { data } = await DiarioEscolarRepository.deleteParecerDescritivo(this.form.identificadorparecerdescritivo);
        this.submitText = data.message;
        this.snackbar = true;

      }catch(error) {
        if(error.response) {
          this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.$router.push({ name: 'diario-escolar-parecer-descritivo',
                          params: {
                                    ano: this.ano,
                                    cdturma: this.cdturma,
                                    disciplina: this.disciplina,
                                    cdinstruc: this.cdinstruc,
                                    tipoDeEnsino: this.tipoDeEnsino
                                  }
                        });

    }
  },
}
</script>

<style lang="scss">
.parecer-labels {
  font-size: 15px;
  margin-bottom: 15px;
}
</style>
